//@flow
import * as React from 'react';
import * as Immutable from 'immutable';
import OutletLocationCodeInput from 'common/entity/generic/OutletLocationCodeInput';
import popOverFactory from 'common/components/core/popover/popOverFactory';
import { Team } from 'common/models/internal/Team';
import { memoizedImmutable } from 'common/utils/Memoizer';
import { OutletLocation } from 'common/models/internal/OutletLocation';
import { type ThemeType } from 'react-css-themr';
import { type TFunction } from 'react-i18next';

type Props = {
    clientId: string,
    existingOutletLocation: ?OutletLocation,
    getLocationFilters: (input: string) => Object,
    theme: ThemeType,
    onChange: (?OutletLocation | Array<OutletLocation>) => void,
    t: TFunction,
    warningMessage: ?string,
    popOverContent: ?string,
    name: string,
    teams: Immutable.List<Team>
};

const OutletLocationCodeInputWithPopover = popOverFactory({
    Component: OutletLocationCodeInput
});

class EntityOutletLocationCodeInput extends React.PureComponent<Props, State> {
    onOutletLocationChange = value => {
        const {
            onChange,
            name,
            existingOutletLocation,
            teams,
            clientId
        } = this.props;

        if (!onChange) {
            return;
        }

        let modifiedValue = value;
        if (modifiedValue) {
            if (Array.isArray(modifiedValue)) {
                modifiedValue = Immutable.List(modifiedValue);
            } else if (value.__isNew__) {
                const { code } = value;
                // Case where a new option is created
                const selectedTeam = this.getTeamDetails(teams);
                const selectedTeamId = selectedTeam?.teamId || null;
                // if the location was already present then we only keep the address
                // and latlng field with the new code provided.
                let addressFields = {};
                if (existingOutletLocation) {
                    addressFields = {
                        address: existingOutletLocation.address?.toJS() || null,
                        latLng: existingOutletLocation.latLng?.toJS() || null
                    };
                }
                modifiedValue = OutletLocation.fromJS({
                    clientId,
                    type: 'CLIENT',
                    name: name ? name : code,
                    teams: selectedTeamId ? [selectedTeamId] : [],
                    ...addressFields
                }).setCode(code);
            }
        } else {
            modifiedValue = existingOutletLocation
                ? existingOutletLocation.setCode(null)
                : OutletLocation.fromJS({
                      type: 'CLIENT'
                  }).setCode(null);
        }
        onChange(modifiedValue);
    };

    @memoizedImmutable()
    getTeamDetails(teams) {
        if (teams.size > 0) {
            return teams.get(0).teamId;
        }
        return null;
    }

    render() {
        return (
            <OutletLocationCodeInputWithPopover
                isPopOverOpen={!!this.props.popOverContent}
                onOutletLocationChange={this.onOutletLocationChange}
                {...this.props}
            />
        );
    }
}

export default EntityOutletLocationCodeInput;
